<template>
  <v-content style="height: 100%">
    <Header :title="section"></Header>

    <v-layout justify-center mt-5>
      <v-flex pa-4>

        <v-layout justify-space-between mb-7>
          <v-flex shrink>

            <v-layout v-if="section === 'tsic'">
              <v-flex pt-3 mr-4>
                กิจกรรมทางเศรษฐกิจ :
              </v-flex>
              <v-flex>
                <v-text-field
                        solo
                        flat
                        v-model="keywordTsicGroup"
                        @keyup.enter="searchTsicGroup"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout v-else-if="section === 'group'">
              <v-flex pt-3 mr-4>
                กลุ่มอุตสาหกรรมสร้างสรรค์ :
              </v-flex>
              <v-flex>
                <v-text-field
                        solo
                        flat
                        v-model="keywordIndustriesGroup"
                        @keyup.enter="searchIndustriesGroup"
                ></v-text-field>
              </v-flex>
            </v-layout>

          </v-flex>
          <v-flex shrink>
            <InputForm :type="section"></InputForm>
          </v-flex>
        </v-layout>

        <!-- Loading overlay -->
        <loading :active.sync="sectionLoaded" :is-full-page="false" loader="bars"></loading>

        <v-layout v-if="section === 'tsic'" justify-center>
          <v-flex>
            <v-simple-table style="border: solid 1px #FF4F23">
              <thead class="white--text" style="background-color: #4F4F4F">
                <tr>
                  <td width="5%">ลำดับ</td>
                  <td width="10%">รหัสกิจกรรม<br>ทางเศรษฐกิจ</td>
                  <td width="60%">กลุ่มอุตสาหกรรมสร้างสรรค์</td>
                  <td width="10%">วันที่สร้าง</td>
                  <td width="5%">แก้ไข</td>
                </tr>
              </thead>
              <tbody>

                <tr v-for="(item, i) in this.tsicList.data" :key="i">
                  <td>{{item.tsic_id}}.</td>
                  <td>{{item.tsic_code}}</td>
                  <td class="text-start">{{item.activity_name_th}}</td>
                  <td>{{item.created_at | moment("DD/MM/YYYY")}}</td>
                  <td><InputForm :type="section" :edit="true" :param="item.tsic_id"></InputForm></td>
                </tr>

              </tbody>
            </v-simple-table>

            <v-layout justify-end mt-3>
              <v-flex shrink v-if="paginationTsic.total > 0">
                <v-pagination v-model="paginationTsic.current"
                              :length="paginationTsic.total"
                              v-if="tsicLoaded"
                              @input="onTsicPageChange"
                              circle
                              color="#FF4F23"
                              :total-visible="pageVisible"
                ></v-pagination>
              </v-flex>
              <v-flex shrink mr-3 v-else>
                ไม่พบรายการข้อมูล
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>

        <v-layout v-else-if="section === 'group'" justify-center>
          <v-flex>
            <v-simple-table style="border: solid 1px #FF4F23">
              <thead class="white--text" style="background-color: #4F4F4F">
              <tr>
                <td width="10%">ลำดับ</td>
                <td width="55%">กลุ่มอุตสาหกรรมสร้างสรรค์</td>
                <td width="12%">รูปไอคอน</td>
                <td width="13%">สถานะ<br>การแสดงข้อมูล</td>
                <td width="10%">แก้ไข</td>
              </tr>
              </thead>
              <tbody>

                <tr v-for="(item, i) in this.industriesList.data" :key="i">
                  <td>{{item.id}}.</td>
                  <td class="text-start">{{item.name_th}}</td>
                  <td>
                    <img v-if="item.icon_path !== ''" :src="http + '/' + item.icon_path" width="64px" height="64px">
                    <span v-else>ไม่มีรูป</span>
                  </td>
                  <td :class="{'cea-color':item.status === 1}">{{item.status === 0 ? 'Inactive':'Active'}}</td>
                  <td><InputForm :type="section" :edit="true" :param="item.id"></InputForm></td>
                </tr>

              </tbody>
            </v-simple-table>

            <v-layout justify-end mt-3>
              <v-flex shrink v-if="paginationIndustries.total > 0">
                <v-pagination v-model="paginationIndustries.current"
                              :length="paginationIndustries.total"
                              v-if="industriesLoaded"
                              @input="onIndustryPageChange"
                              circle
                              color="#FF4F23"
                              :total-visible="pageVisible"
                ></v-pagination>
              </v-flex>
              <v-flex shrink mr-3 v-else>
                ไม่พบรายการข้อมูล
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>

        <!-- Number box -->
        <v-layout v-else-if="section === 'number-box-datastats'" justify-center>
          <v-flex xs12>

            <v-layout justify-center>
              <v-flex xs10>
                <v-layout justify-end>
                  <v-flex shrink pt-3 mr-3>
                    กล่องแสดงข้อมูลกล่องแรกผูกกับข้อมูล :
                  </v-flex>
                  <v-flex xs7>
                    <v-select
                            v-model="numberBox.box1"
                            :items="allTopicSelect"
                            solo flat></v-select>
                  </v-flex>
                </v-layout>

                <v-layout justify-end>
                  <v-flex shrink pt-3 mr-3>
                    กล่องแสดงข้อมูลกล่องที่สองผูกกับข้อมูล :
                  </v-flex>
                  <v-flex xs7>
                    <v-select
                            v-model="numberBox.box2"
                            :items="allTopicSelect"
                            solo flat></v-select>
                  </v-flex>
                </v-layout>

                <v-layout justify-end>
                  <v-flex shrink pt-3 mr-3>
                    กล่องแสดงข้อมูลกล่องที่สามผูกกับข้อมูล :
                  </v-flex>
                  <v-flex xs7>
                    <v-select
                            v-model="numberBox.box3"
                            :items="allTopicSelect"
                            solo flat></v-select>
                  </v-flex>
                </v-layout>

                <v-layout justify-end>
                  <v-btn large color="#FF4F23" class="white--text mb-3" @click="saveNumberBox">บันทึก</v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>



      </v-flex>
    </v-layout>

  </v-content>
</template>

<script>
  import Header from '../components/Header'
  import InputForm from "../components/InputForm"
  import { mapState, mapActions } from 'vuex'
  import { domain } from '../services/Constants'
  import Service from '../services'
  import Loading from 'vue-loading-overlay'
  import Swal from "sweetalert2";
export default {
  name: 'creative-industries',
  props: ['section'],
  components: {
    Header,
    InputForm,
    Loading
  },
  data: () => ({
    dataParam: {},
    keywordTsicGroup: '',
    keywordIndustriesGroup: '',
    tsicLoaded: false,
    industriesLoaded: false,
    pageVisible: 8,
    http: domain,
    paginationTsic: {
      current: 1,
      total: 1,
      itemPerPage: 10 // follow API
    },
    paginationIndustries: {
      current: 1,
      total: 1,
      itemPerPage: 10 // follow API
    },
    numberBox: {
      box1: null,
      box2: null,
      box3: null
    },
    sectionLoaded: true
  }),
  computed: {
    ...mapState({
      userData: state => state.auth.userData,
      tsicList: state => state.tsic.allTsicPaginate,
      industriesList: state => state.tsic.allIndustriesPaginate,
      allTopicSelect: state => {
        return [
          ...state.data.allTopic.map(topic => ({
            text: topic.name_th,
            value: topic.id
          }))
        ]
      },
      numberBoxDataStats: state => state.data.numberBoxDataStats
    })
  },
  created() {
    this.dataParam.token = this.userData.token;
    this.onGetAllTsicPaginate(this.dataParam).then(() => {
      this.onTsicPageChange()
    });
    this.onGetAllIndustriesPaginate(this.dataParam).then(() => {
      this.onIndustryPageChange();
    });
    this.populateNumberBoxDataStats().then(() => {
      this.numberBox.box1 = this.numberBoxDataStats[0].topic_id;
      this.numberBox.box2 = this.numberBoxDataStats[1].topic_id;
      this.numberBox.box3 = this.numberBoxDataStats[2].topic_id;
    })

  },
  watch: {
    // re-render pagination
    section: function () {
      this.tsicLoaded = false;
      this.industriesLoaded = false;
      setTimeout(() => {
        this.tsicLoaded = true;
        this.industriesLoaded = true;
      }, 1);
    }
  },
  methods: {
    ...mapActions('tsic',['onGetAllTsicPaginate','onGetTsic','onGetAllIndustriesPaginate','onGetIndustry']),
    ...mapActions('data',['updateNumberBoxDataStats','populateNumberBoxDataStats']),
    onTsicPageChange(page) {

      let data = { page: page, token: this.userData.token };

      this.paginationTsic.total = Math.ceil(this.tsicList.total / this.paginationTsic.itemPerPage);

      Service.tsic.getAllTsicPaginate(data).then((res) => {
        // console.log(res);
        this.paginationTsic.current = res.current_page;
        this.tsicList.data = res.data;
        this.tsicLoaded = true;
      }).then(() => {
        this.sectionLoaded = false; // set finish loading
      })

    },
    onIndustryPageChange(page) {
      let data = { page: page, token: this.userData.token };

      this.paginationIndustries.total = Math.ceil(this.industriesList.total / this.paginationIndustries.itemPerPage);

      Service.tsic.getAllIndustriesPaginate(data).then((res) => {
        this.paginationIndustries.current = res.current_page;
        this.industriesList.data = res.data;
        this.industriesLoaded = true;
      }).then(() => {
        this.sectionLoaded = false; // set finish loading
      })

    },
    async saveNumberBox() {
      if (this.numberBox.box1 === this.numberBox.box2 || this.numberBox.box1 === this.numberBox.box3 || this.numberBox.box2 === this.numberBox.box3) {
        Swal.fire({
          icon: 'warning',
          text: 'ห้ามเลือกข้อมูลซ้ำ',
        })
        // alert('ห้ามเลือกข้อมูลซ้ำ');
        return
      }

      try {
        const numberBoxes = await Promise.all([
          this.updateNumberBoxDataStats({
            id: 1,
            topic_id: this.numberBox.box1
          }),
          this.updateNumberBoxDataStats({
            id: 2,
            topic_id: this.numberBox.box2
          }),
          this.updateNumberBoxDataStats({
            id: 3,
            topic_id: this.numberBox.box3
          })
        ])
        Swal.fire({
          icon: 'warning',
          title:'สำเร็จ!',
          text: 'แก้ไขข้อมูลสำเร็จ',
        })
        // alert('แก้ไขข้อมูลสำเร็จ')
      }
      catch (err) {
        Swal.fire({
          icon: 'error',
          title:'ผิดพลาด!',
          text: err.message,
        })
        // alert(err.message)
      }
    },
    searchTsicGroup () {
      let param = { keyword: this.keywordTsicGroup, token: this.userData.token };
      this.sectionLoaded = true;

      if (param.keyword === '') {
        this.onGetAllTsicPaginate(this.dataParam).then(() => {
          this.onTsicPageChange()
        });
        return;
      }

      Service.tsic.searchTsic(param).then((res) => {
        this.tsicList.data = res;
        this.tsicLoaded = false;
      }).then(() => {
        this.sectionLoaded = false; // set finish loading
      })
    },
    searchIndustriesGroup () {
      let param = { keyword: this.keywordIndustriesGroup, token: this.userData.token };
      this.sectionLoaded = true;

      if (param.keyword === '') {
        this.onGetAllIndustriesPaginate(this.dataParam).then(() => {
          this.onIndustryPageChange();
        });
        return;
      }

      Service.tsic.searchIndustries(param).then((res) => {
        this.industriesList.data = res;
        this.industriesLoaded = false;
      }).then(() => {
        this.sectionLoaded = false; // set finish loading
      })
    }
  }
}
</script>

<style scoped>

  .theme--light.v-data-table thead tr td:not(:last-child),
  .theme--light.v-data-table tbody tr td:not(:last-child) {
    border-right: solid 1px #D7D7D7 !important;
  }

</style>
